export default [
    {
        path: 'fornecedor',
        component: () => import(
            /* webpackChunkName: 'cadastro-fornecedor' */
            '@/views/cadastro/fornecedor/Index'
        ),
        redirect: 'fornecedor/index',
        children: [
            {
                name: 'cadastro-fornecedor-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-fornecedor' */
                    '@/views/cadastro/fornecedor/List.vue'
                ),
            },
            {
                name: 'cadastro-fornecedor-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-fornecedor' */
                    '@/views/cadastro/fornecedor/Form.vue'
                ),
            },
            {
                name: 'cadastro-fornecedor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-fornecedor' */
                    '@/views/cadastro/fornecedor/Form.vue'
                ),
            },
        ],
    },
]